import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { EmptyState, StatusBadge } from "@/components/ui/bits";
import { gbp, fmtDate } from "@/lib/constants";
import { Receipt } from "lucide-react";

export default function ClientInvoices() {
  const { user } = useAuth();
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    api.get(`/invoices?client_id=${user.client_id}`).then(({ data }) => setInvoices(data)).catch(() => {});
  }, [user.client_id]);
  return (
    <div>
      <h1 className="font-serif font-bold text-3xl text-white mb-1">Invoices</h1>
      <p className="text-slate-400 mb-5">Your billing history with JTS Swanson.</p>
      {invoices.length === 0 ? <EmptyState icon={Receipt} title="No invoices yet" /> : (
        <div className="space-y-2">
          {invoices.map((inv) => (
            <div key={inv.id} className="card-surface rounded-xl p-4 flex items-center justify-between">
              <div>
                <div className="text-white font-medium">{inv.number} · {gbp(inv.amount)}</div>
                <div className="text-slate-500 text-sm">{inv.period} · due {fmtDate(inv.due_date)}</div>
                {inv.description && <div className="text-slate-500 text-xs mt-0.5">{inv.description}</div>}
              </div>
              <StatusBadge status={inv.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
